export const CART_CHANGED_EVENT_NAME = 'Cart.Changed';
export const ORIGIN_CART = 'cart';
